/* import __COLOCATED_TEMPLATE__ from './paywall-splash.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();